exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sectionSubList_2XLLq {\n    list-style: none;\n    position: relative;\n}\n\n.sectionListChild_3x5OQ {\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.sectionListChild_3x5OQ input {\n    position: absolute;\n    left: 10px;\n    line-height: 20px;\n}\n\n.sectionListChild_3x5OQ > p {\n    font-size: 12px;\n    margin: 0;\n}\n", ""]);

// exports
exports.locals = {
	"sectionSubList": "sectionSubList_2XLLq",
	"sectionListChild": "sectionListChild_3x5OQ"
};